<template>
  <h2 class="mb-3 text-left">{{ typeName }}<label style="color: brown; padding-left: 50px;" v-if="isSet">選択中</label></h2>
  <dl class="c-radio mb-3 pb-3 border-bottom">
    <dt class="pl-1">
      <label :for="sequentialNo" class="name">{{ destName }}</label>
    </dt>
    <dd class="pl-2 d-flex column_sp justify-content-between">
      住所：〒{{ zipCode }}&emsp;{{ address1 + address2 }}<br />
      電話：{{ tel }}<br />
      お届け予定日：{{ shortestDate }}
      <div class="delete text-center mt-4 mr-4 d-flex align-items-center">
        <button style="width: 80px;" @click="setAddress" v-if="!isSet">選択</button>
        <button style="width: 80px; margin-left: 20px;" v-show="type > 0" @click="deleteAddress">削除</button>
      </div>
    </dd>
  </dl>
</template>

<script>
import Request from "@/modules/Request";
import Message from "@/modules/Message";
let request = new Request();

export default {
  props: [
    "type",
    "typeName",
    "sequentialNo",
    "destName",
    "zipCode",
    "address1",
    "address2",
    "tel",
    "shortestDate",
    "deliveryAddressNo",
  ],
  emits: ["updateAddress", "selectAddress"],
  data() {
    return {
      addressNo: this.deliveryAddressNo,
      isSet : this.deliveryAddressNo == this.sequentialNo ? true :false,
    };
  },
  watch: {
    deliveryAddressNo: function(val) {
      console.log('addresitem:'+val)
      this.isSet = this.sequentialNo == val ? true : false
    }
  },
  methods: {
    selectAddress() {
      console.log('selectaddress')
      console.log(this.sequentialNo)
      this.$emit("selectAddress", this.addressNo);
    },
    setAddress(){
      this.$emit("selectAddress", this.sequentialNo);
    },
    deleteAddress() {
      Message.confirm()
      .fire({
        title: "削除します。宜しいですか？",
      }).then((result) => {
          if (result.isConfirmed) {
            let postParams = [this.sequentialNo];
            let requestParams = request.createParams(
              "webMdlShippingAddress",
              "delAddress",
              postParams
            );
            request
              .create()
              .post("", requestParams)
              .then(() => {
                Message.success().fire({
                  title: "住所を削除しました"
                });

                this.$emit("updateAddress");
              });
          }
      });
    },
  },
};
</script>